import React from 'react';
// eslint-disable-next-line import/no-internal-modules
import { renderToStaticMarkup } from 'react-dom/server';
import { PageLoading } from 'components/atoms/loading';

export const overlayLoadingTemplate = renderToStaticMarkup(<PageLoading css />);
